import { useMemo, useState } from "react";
import { DateTime } from "luxon";
import { IDashboardStats } from "../../../models/DashboardStats";
import DashboardStatTableTabs from "../Tabs/DashboardStatTableTabs";
import ActivityTable from "./ActivityTable";

const tabs = [
  { name: "Today", value: "today" },
  { name: "Week", value: "week" },
  { name: "Month", value: "month" },
];

interface IPartsUserActivityTableProps {
  todayStats: IDashboardStats;
  weekStats: IDashboardStats;
  monthStats: IDashboardStats;
  title: string;
  rowLabelColumn: string;
}

export default function PartsUserActivityTable({
  todayStats,
  weekStats,
  monthStats,
  title,
  rowLabelColumn,
}: IPartsUserActivityTableProps) {
  const [timeframe, setTimeframe] = useState("today");

  const selectedStats = useMemo(
    () => (timeframe === "week" ? weekStats : timeframe === "month" ? monthStats : todayStats),
    [timeframe, todayStats, weekStats, monthStats]
  );

  const daysInPeriod = useMemo(() => {
    if (timeframe === "today") return 1;
    if (timeframe === "week") return DateTime.now().weekday;
    return DateTime.now().day;
  }, [timeframe]);

  return (
    <ActivityTable
      title={title}
      rowLabelColumn={rowLabelColumn}
      activityByUser={selectedStats.userActivity}
      activityTotal={selectedStats.userActivityTotal}
      daysInPeriod={daysInPeriod}
      headerControls={
        <DashboardStatTableTabs
          tabs={tabs}
          value={timeframe}
          onChange={setTimeframe}
          ariaLabel="Select a tab"
        />
      }
    />
  );
}
